import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Container,
  Content,
  Header,
  BackButton,
  Title,
  LastUpdated,
  Section,
  SectionTitle,
  Paragraph,
  List,
  ListItem,
  SubSection,
  SubSectionTitle,
  Footer,
  HomeButton,
} from './styled'

export const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate()

  return (
    <Container>
      <Content>
        <Header>
          <BackButton onClick={() => navigate(-1)}>← Back</BackButton>
          <Title>Privacy Policy</Title>
          <LastUpdated>Last updated: December 2024</LastUpdated>
        </Header>

        <Section>
          <SectionTitle>1. Introduction</SectionTitle>
          <Paragraph>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </Paragraph>
          <Paragraph>
            Duis aute irure dolor in reprehenderit in voluptate velit esse
            cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
            cupidatat non proident.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>2. Information We Collect</SectionTitle>
          <Paragraph>
            Sunt in culpa qui officia deserunt mollit anim id est laborum. We
            collect the following types of information:
          </Paragraph>

          <SubSection>
            <SubSectionTitle>2.1 Personal Information</SubSectionTitle>
            <List>
              <ListItem>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit
              </ListItem>
              <ListItem>Sed do eiusmod tempor incididunt ut labore</ListItem>
              <ListItem>
                Ut enim ad minim veniam, quis nostrud exercitation
              </ListItem>
            </List>
          </SubSection>

          <SubSection>
            <SubSectionTitle>2.2 Usage Information</SubSectionTitle>
            <Paragraph>
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem
              accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
              quae ab illo inventore.
            </Paragraph>
          </SubSection>

          <SubSection>
            <SubSectionTitle>2.3 Device Information</SubSectionTitle>
            <List>
              <ListItem>
                Veritatis et quasi architecto beatae vitae dicta
              </ListItem>
              <ListItem>Nemo enim ipsam voluptatem quia voluptas sit</ListItem>
              <ListItem>
                Aspernatur aut odit aut fugit, sed quia consequuntur
              </ListItem>
            </List>
          </SubSection>
        </Section>

        <Section>
          <SectionTitle>3. How We Use Your Information</SectionTitle>
          <Paragraph>
            Magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro
            quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur,
            adipisci velit:
          </Paragraph>
          <List>
            <ListItem>Sed quia non numquam eius modi tempora incidunt</ListItem>
            <ListItem>
              Ut labore et dolore magnam aliquam quaerat voluptatem
            </ListItem>
            <ListItem>
              Ut enim ad minima veniam, quis nostrum exercitationem
            </ListItem>
            <ListItem>
              Ullam corporis suscipit laboriosam, nisi ut aliquid
            </ListItem>
            <ListItem>Ex ea commodi consequatur quis autem vel eum</ListItem>
          </List>
        </Section>

        <Section>
          <SectionTitle>4. Information Sharing and Disclosure</SectionTitle>
          <Paragraph>
            Iure reprehenderit qui in ea voluptate velit esse quam nihil
            molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas
            nulla pariatur. At vero eos et accusamus et iusto odio dignissimos
            ducimus.
          </Paragraph>
          <Paragraph>
            Qui blanditiis praesentium voluptatum deleniti atque corrupti quos
            dolores et quas molestias excepturi sint occaecati cupiditate non
            provident, similique sunt in culpa.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>5. Data Security</SectionTitle>
          <Paragraph>
            Qui officia deserunt mollitia animi, id est laborum et dolorum fuga.
            Et harum quidem rerum facilis est et expedita distinctio. Nam libero
            tempore, cum soluta nobis est eligendi optio cumque nihil impedit
            quo minus id quod maxime placeat.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>6. Your Rights and Choices</SectionTitle>
          <Paragraph>
            Facere possimus, omnis voluptas assumenda est, omnis dolor
            repellendus. Temporibus autem quibusdam et aut officiis debitis aut
            rerum necessitatibus saepe eveniet:
          </Paragraph>
          <List>
            <ListItem>
              Ut et voluptates repudiandae sint et molestiae non recusandae
            </ListItem>
            <ListItem>
              Itaque earum rerum hic tenetur a sapiente delectus
            </ListItem>
            <ListItem>
              Ut aut reiciendis voluptatibus maiores alias consequatur
            </ListItem>
            <ListItem>Aut perferendis doloribus asperiores repellat</ListItem>
          </List>
        </Section>

        <Section>
          <SectionTitle>7. Cookies and Tracking Technologies</SectionTitle>
          <Paragraph>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>8. Children's Privacy</SectionTitle>
          <Paragraph>
            Duis aute irure dolor in reprehenderit in voluptate velit esse
            cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
            cupidatat non proident, sunt in culpa qui officia deserunt mollit
            anim id est laborum.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>9. International Data Transfers</SectionTitle>
          <Paragraph>
            Sed ut perspiciatis unde omnis iste natus error sit voluptatem
            accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
            quae ab illo inventore veritatis et quasi architecto beatae vitae
            dicta sunt explicabo.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>10. Changes to This Privacy Policy</SectionTitle>
          <Paragraph>
            Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut
            fugit, sed quia consequuntur magni dolores eos qui ratione
            voluptatem sequi nesciunt.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>11. Contact Us</SectionTitle>
          <Paragraph>
            If you have any questions about this Privacy Policy, please contact
            us at:
          </Paragraph>
          <Paragraph>
            Email: privacy@quickcasa-waypoint.com
            <br />
            Data Protection Officer: Lorem Ipsum
            <br />
            Address: Lorem ipsum dolor sit amet, consectetur adipiscing elit
            <br />
            Phone: +1 (555) 123-4567
          </Paragraph>
        </Section>

        <Footer>
          <HomeButton onClick={() => navigate('/')}>
            Return to Dashboard
          </HomeButton>
        </Footer>
      </Content>
    </Container>
  )
}
